import type { AuthStep } from '@dreamstack/auth'
import { useAuthModalContext } from '@dreamstack/auth'
import { ArrowLeft } from '@dreamstack/icons/src/icon-components/ArrowLeft'
import type { FunctionComponent } from 'react'

export const AuthBackButton: FunctionComponent<
  React.PropsWithChildren<{ toStep: AuthStep }>
> = ({ toStep }) => {
  const { setActiveStep } = useAuthModalContext()
  return (
    <ArrowLeft
      onClick={() => setActiveStep(toStep)}
      className="w-px-40 h-px-40 mr-px-16 md:mr-px-24 cursor-pointer flex-shrink-0"
    />
  )
}
